import React from 'react'
import { ThemeProvider, createGlobalStyle } from 'styled-components'

const mainTheme = {
  color: {
    face: {
      main: '#17546D',
      contrast: '#F3954A',
      secondary: '#D6EDF8',
      secondaryLight: '#EDF8FD',
      secondaryDark: '#A1C1CC',
      light: '#FFFFFF'
    },

    text: {
      main: '#17546D',
      contrast: '#F3954A',
      secondary: '#D6EDF8',
      light: '#FFFFFF',
      positive: '#3DBC4A',
      negative: '#F2665B',
    },

    gradient: {
      main: {
        from: '0,120,154',
        to: '0,86,113'
      },
      contrast: {
        from: '255,183,83',
        to: '255,145,51'
      }
    }
  },

  font: {
    family: {
      main: 'proxima-nova, sans-sarif',
      alternative: 'Caveat, cursive'
    },

    size: {
      xxs: '8px',
      xs: '10px',
      s: '12px',
      sm: '14px',
      m: '16px',
      xsm: '18px',
      xm: '20px',
      l: '24px',
      xlm: '26px',
      xl: '32px',
      xxl: '45px',
      xxxl: '70px',
    },

    weight: {
      xs: 200,
      s: 300,
      m: 400,
      l: 600,
      xl: 800,
    }
  }
}

const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    overflow: ${props => props.isScrollable ? 'initial' : 'hidden'};
  }

  body {
    font-family: ${props => props.theme.font.family.main};
    font-size: ${props => props.theme.font.size.m};
    color: ${props => props.theme.color.text.main};
  }

  ${props => Object.keys(props.theme.color.face).map(key => `.color-background-${key} { background-color: ${props.theme.color.face[key]}; }`)}

  ${props => Object.keys(props.theme.color.text).map(key => `.color-${key} { color: ${props.theme.color.text[key]}; }`)}

  ${props => Object.keys(props.theme.font.family).map(key => `.font-family-${key} { font-family: ${props.theme.font.family[key]}; }`)}

  ${props => Object.keys(props.theme.font.size).map(key => `.font-size-${key} { font-size: ${props.theme.font.size[key]}; }`)}

  ${props => Object.keys(props.theme.font.weight).map(key => `.font-weight-${key} { font-weight: ${props.theme.font.weight[key]}; }`)}

  a:hover {
    text-decoration: underline;
    color: inherit;
  }

  #rcc-confirm-button {
    background-color: ${props => props.theme.color.face.contrast} !important;
    color: ${props => props.theme.color.text.light} !important;
    font-weight: ${props => props.theme.font.weight.s} !important;
    border-radius: 20px !important;
    padding: 5px 20px !important;

    &:hover {
      color: ${props => props.theme.color.text.light};
      text-decoration: underline;
    }
  }
`

const Theme = ({ children, isScrollable }) => (
  <ThemeProvider theme={mainTheme}>
    <GlobalStyle isScrollable={isScrollable} />
    {children}
  </ThemeProvider>
)

export default Theme